import { Card, CardHeader, IconButton } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Popover from '@material-ui/core/Popover';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import React, { useState } from 'react';
import './images-viewer.css';
import { ImageTooltip } from './image-tooltip';
import { JobImageType } from 'models/jobs/jobs';
export const ImagesViewer = ({ mainImage, imageType, jobResult, children }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleDownload = (url) => {
        const [path] = url.split('?');
        if (!path) {
            return;
        }
        const fileName = path.slice(path.lastIndexOf('/') + 1);
        setAnchorEl(null);
        fetch(url)
            .then(async (response) => response.blob())
            .then((blob) => {
            const objUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = objUrl;
            a.download = fileName;
            a.click();
        })
            .catch(console.error);
    };
    const open = Boolean(anchorEl);
    const showJobImage = jobResult && imageType !== undefined && imageType !== JobImageType.Selfie;
    let title;
    let id;
    let country;
    let state;
    let type;
    let version = '';
    if (showJobImage) {
        ({ id, country, state, type, version } = jobResult);
        title = [
            jobResult.id,
            jobResult.country,
            jobResult.state,
            jobResult.type,
            jobResult.version
        ]
            .filter((data) => !!data)
            .join(' - ');
    }
    else {
        title = 'Selfie image';
    }
    return (React.createElement(Card, null,
        jobResult && (React.createElement(ImageTooltip, { country: country, disable: !showJobImage, id: id, state: state, type: type, version: version },
            React.createElement("div", null,
                React.createElement(CardHeader, { action: React.createElement(IconButton, { "aria-label": "settings", onClick: handleClick },
                        React.createElement(MoreVertIcon, null)), title: title })))),
        React.createElement("div", { className: "card-content" }, children),
        React.createElement(Popover, { anchorEl: anchorEl, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, id: "menu-popover", onClose: handleClose, open: open, transformOrigin: {
                vertical: 'top',
                horizontal: 'right'
            } },
            React.createElement(List, null,
                React.createElement(ListItem, { className: "pointer", onClick: () => {
                        handleDownload(mainImage.url);
                    } },
                    React.createElement("span", { className: "pointer fas fa-download" }),
                    React.createElement(ListItemText, { primary: "Download File" }))))));
};
